import type { GenerateMatrixResult } from "../domain/engine";
import type { FailureCase } from "../domain/failure-rules";
import type { RunState } from "../hooks/useEngine";
import { FindingsList } from "./FindingsList";
import { CoverageMeter } from "./CoverageMeter";
import { MatrixTable } from "./MatrixTable";
import { ExportPanel } from "./ExportPanel";

interface ResultPanelProps {
  runState: RunState;
  engineResult: GenerateMatrixResult | null;
  onOverride: (caseId: string, patch: Partial<Pick<FailureCase, "justification" | "accepted" | "reviewed">>) => void;
}

const STATUS_COPY: Record<string, { label: string; tone: string }> = {
  completed: { label: "Ejecución terminada", tone: "success" },
  partial: { label: "Ejecución parcial", tone: "warning" },
  failed: { label: "Ejecución fallida", tone: "critical" },
  cancelled: { label: "Cancelada por el visitante", tone: "info" },
};

export function ResultPanel({ runState, engineResult, onOverride }: ResultPanelProps) {
  return (
    <section aria-labelledby="result-heading">
      <h2 className="section-heading" id="result-heading">
        Resultado
      </h2>
      <div className="panel" role="status" aria-live="polite">
        {runState === "idle" || !engineResult ? (
          <div className="empty-state">
            <p>Aún no hay resultado. Ejecuta el fixture para ver cada decisión.</p>
          </div>
        ) : (
          <>
            <div className="action-row" style={{ marginBottom: "var(--space-4)" }}>
              <span className={`state-badge state-badge--${STATUS_COPY[engineResult.output.status]?.tone ?? "info"}`}>
                {STATUS_COPY[engineResult.output.status]?.label ?? engineResult.output.status}
              </span>
              <code>{engineResult.output.runId}</code>
            </div>
            <p>{engineResult.output.summary}</p>
            <FindingsList findings={engineResult.output.findings} />
            {engineResult.matrix.length > 0 ? <CoverageMeter coverage={engineResult.coverage} /> : null}
            <h3>Operaciones y seguridad</h3>
            <MatrixTable matrix={engineResult.matrix} onOverride={onOverride} />
            {engineResult.matrix.length > 0 ? <ExportPanel engineResult={engineResult} /> : null}
          </>
        )}
      </div>
    </section>
  );
}
